export const TERMS_CYCLIC_LINKS = {
  pl: '/files/plus/Regulamin-automatycznych-doladowan-Plus.pdf',
  en: '/files/plus/Regulamin-automatycznych-doladowan-Plus_en.pdf',
  uk: '/files/plus/Regulamin-automatycznych-doladowan-Plus_en.pdf'
}

export const TERMS_TOPUP_LINKS = {
  pl: '/files/plus/Regulamin-doladowan-PLUS.pdf',
  en: '/files/plus/Regulamin-doladowan-PLUS_en.pdf',
  uk: '/files/plus/Regulamin-doladowan-PLUS_en.pdf'
}
